// Bundle UI da ficha `inspection-v1` (espelha a chave `templateVersion` do back).
//
// Tudo que *é* a ficha desta versão mora nesta pasta: catálogo de itens, ordem
// dos steps, componentes de cada step, regras de desbloqueio e finalização.
// Nova inspeção (cabeçalho / POST Y=4) fica fora — o slot só monta `Form`
// depois do GET Y=5.

import type { InspectionFormBundle } from "../inspection-form-bundle";
import InspectionV1Form from "./InspectionV1Form";

export const INSPECTION_FORM_V1 = "inspection-v1";

export const inspectionFormBundleV1: InspectionFormBundle = {
  version: INSPECTION_FORM_V1,
  Form: InspectionV1Form,
};
